import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useUDData } from '@udemy/ud-data';
import { getBrowseURL } from '../../../get-browse-url';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../../../mobile/mobile-nav/mobile-nav.react-component';
export const MobileSubcategoryNav = ({
  parentCategory,
  subcategories
}) => {
  const {
    gettext,
    interpolate
  } = useI18n();
  const udData = useUDData();
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: `header-toggle-side-nav-subcategories-of-${parentCategory.id}`
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
    href: getBrowseURL(parentCategory.absolute_url, udData.Config.brand.has_organization)
  }, /*#__PURE__*/React.createElement("span", {
    className: "ud-heading-md"
  }, interpolate(gettext('All %(category)s'), {
    category: parentCategory.title
  }, true))), subcategories.map(subcategory => /*#__PURE__*/React.createElement(MobileNavItem, {
    key: subcategory.id,
    href: getBrowseURL(subcategory.absolute_url, udData.Config.brand.has_organization),
    "data-purpose": "subcategory-item"
  }, subcategory.title))));
};
//# sourceMappingURL=mobile-subcategory-nav.react-component.js.map